/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './sidenav-module';
export {
  throwMatDuplicatedDrawerError,
  MatDrawerToggleResult,
  MAT_DRAWER_DEFAULT_AUTOSIZE,
  MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY,
  MatDrawerContent,
  MatDrawer,
  MatDrawerContainer,
  MatDrawerMode,
} from './drawer';
export * from './sidenav';
export * from './drawer-animations';
